import { render, staticRenderFns } from "./exoneracoesPendentes.vue?vue&type=template&id=58d3de83"
import script from "./exoneracoesPendentes.vue?vue&type=script&lang=js"
export * from "./exoneracoesPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports